import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './contexts/CartContext';
import { applyTheme } from './themeConfig';

// Apply theme before render so CSS variables are ready
applyTheme();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
   <CartProvider>
      <App />
   </CartProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
